import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ReactPhoneInput from "react-phone-input-2";
import Notify from "../../../Common/Notify";
import PUBNUB from "pubnub";
import Parse from "parse";
import config from "../../../../config";
import { parseAction } from "../../../../actions/REST";
import { ToastContainer } from "react-toastify";
import {
  registerQueue,
  getQueue,
} from "../../../../actions/PatientAction";
import Spinner from "../../../Common/Spinner";
import Logo from "../../../../assets/images/logo-blue.png";
import "./PatientQueue.css";

let PubNub = null;
let subscribedChannels = null;

const PatientQueue = ({ qrCode = "", ticket = "", queue = "", history }) => {
  const dispatch = useDispatch();

  const [code, setCode] = useState("");
  const [tick, setTicket] = useState("");
  const [queueCode, setQueueCode] = useState(0);
  const [currentServing, setCurrentServing] = useState(null);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [patientQueue, setPatientQueue] = useState("");

  const listiningTo = {
    message: (m) => {
      const ping = m;
      if (
        ping &&
        ping.channel === ("queue_patient_channel_" + qrCode) &&
        ping.message &&
        ping.message.type === "get_queue_for_patient"
      ) {
        setCurrentServing(ping.message.current_serving);
        // setCurrentServing({
        //   current_serving: ping.message.current_serving,
        //   content_available: ping.message["content-available"],
        // });
      }
    },
  };

  useEffect(() => {
    if (qrCode !== "") {
      setCode(qrCode);
      fetchPubNubKey(qrCode);
    } else {
      const route = "/u";
      history.push(route);
    }
  }, [qrCode]);

  useEffect(() => {
    if (ticket === "") return;

    setTicket(ticket);
    handleGetQueue(ticket, qrCode);
  }, [ticket]);
  
  useEffect(() => {
    if (queue === "") return;

    setPatientQueue(queue);
  }, [queue]);

  const fetchPubNubKey = (qrCode) => {
    parseAction("post", config.BASE_URL + "/parse/functions/getPubNubKeys")
      .then((keys) => {
        initializePubNub(keys.result, qrCode);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const initializePubNub = (keys, qrCode) => {
    PubNub = new PUBNUB({
      publish_key: keys.publishKey,
      subscribe_key: keys.subscribeKey,
      ssl: window.location.protocol.toLowerCase() === "https:",
      origin: "pubsub.pubnub.com",
      uuid: Parse.User.current().id,
      presenceTimeout: 120,
      heartbeatInterval: 30,
    });

    PubNub.addListener(listiningTo);
    subscribedChannels = ["queue_patient_channel_" + qrCode];
    // console.log('channels:', subscribedChannels)
    PubNub.subscribe({ channels: subscribedChannels });
  };

  const handleRegisterQueue = () => {
    if (name !== "" && phoneNumber !== "") {
      const info = {
        name: name,
        mobile_number: phoneNumber,
        code: code,
      }
      dispatch(registerQueue(info))
        .then((res) => {
          const route = "/patient-queue/" + code + "/" + res.registration.ticket_id + "/" + res.ticket_number;
          history.push(route);
        })
    } else {
      Notify.info("Name and Phone number required.");
    }
  }

  const handleGetQueue = (id, queuing_code) => {
    const params = {
      queue_code: queuing_code,
      ticket_id: id,
    };
    dispatch(getQueue(params))
      .then((res) => {
        setCurrentServing(res.current_serving);
      })
  }

  return (
    <div className="PatientQueue-container">
      <div className="PatientQueue-form">
        {tick === "" &&
          <>
          <h4 className="hc-primary-text">PATIENT WAITING FORM</h4>
          <div className="PatientQueue-form-registration Form-Container form-bypass">
            <>
              <label for="" className="label-cls">
                Patient Name:
              </label>
              <div className="form-group">
                <div className="card">
                  <input
                    id="name"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    placeholder="Name"
                    required
                  />
                  <i className="fas fa-user hc-primary-text"></i>
                </div>
              </div>
              <label for="" className="label-cls">
                Patient Number:
              </label>
              <div className="form-group">
                <div className="card" style={{ paddingLeft: "0px" }}>
                  <ReactPhoneInput
                    country={"us"}
                    defaultCountry={"us"}
                    enableLongNumbers={true}
                    onChange={(e) => setPhoneNumber(e)}
                    value={phoneNumber}
                    inputStyle={{
                      width: "100%",
                      outline: "none",
                      boxShadow: "none",
                    }}
                  />
                </div>
              </div>
              <button
                className="btn btn-hubchart btn-hubchart-close"
                onClick={() => handleRegisterQueue()}
              >
                Submit
              </button>
            </>
          </div>
          </>
        }
        {tick !== "" &&
        <>
          <div className="PatientQueue-form-main shadow-sm" style={{ margin: "10px 0px"}}>
            <span>
              <div style={{ fontWeight: "bold" }}>CURRENT NUMBER</div>
            </span>
            <span>
              {currentServing}
            </span>
          </div>
          <div className="PatientQueue-form-sub shadow-sm">
            {patientQueue === "" ?
              <></>
              :
              <div className="Patient-form-waiting">
                <span>Your</span>
                <span>Patient Number</span>
                <div>
                  {patientQueue}
                </div>
                {name !== "" && phoneNumber !== "" ?
                  <>
                    <span></span>
                    <span>{name}</span>
                    <span>{phoneNumber}</span>
                  </>
                  : <></>
                }
              </div>
            }
          </div>
        </>
        }
        <img className="Logo" src={Logo} alt="Hubchart Logo" />
        <h4 className="hc-primary-text">HUBCHART</h4>
      </div>
      <ToastContainer />
    </div>
  );
};

export default PatientQueue;
